export default __webpack_public_path__ + "static/media/xp-bars.efa6a391.svg";